import React from 'react';
import { connect } from 'react-redux';

import { logoutAction } from '../../../state/actions/creators/auth.actioncreator';
import { Box } from '../../shared/components/basic';

const Main = ({ logout }) => (
  <Box p={4}>
    <button onClick={logout}>Logout</button>
  </Box>
);

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logoutAction()),
});

export default connect(
  null,
  mapDispatchToProps,
)(Main);
